import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import './LightBox.scss'

const CLASS = 'insights-light-box'

let lightBox = null

const hideLightBox = () => {
  document.removeEventListener('click', hideLightBox)
  document.removeEventListener('keydown', hideLightBox)
  lightBox = lightBox || document.querySelector(`.${CLASS}`)
  if (lightBox) {
    document.body.removeChild(lightBox)
    lightBox = null
  }
}

const showLightBox = ({ className, src }) => {
  lightBox = document.createElement('div')
  lightBox.classList.add(CLASS)
  if (className) {
    lightBox.classList.add(className)
  }
  const lightBoxContent = (
    <div className={`${CLASS}-content`}>
      <img className={`${CLASS}-content-image`} src={src} />
    </div>
  )
  ReactDOM.render(lightBoxContent, document.body.appendChild(lightBox))
  document.addEventListener('click', hideLightBox)
  document.addEventListener('keydown', hideLightBox)
}

const LightBox = props => {
  const className = props.className || null
  const src = props.src || null

  const onTargetRef = useRef()
  onTargetRef.current = props.onTarget || null

  useEffect(() => {
    const target = onTargetRef.current ? onTargetRef.current() : null
    if (target) {
      const onShow = event => {
        event.stopPropagation()
        if (lightBox) {
          hideLightBox()
        }
        showLightBox({ className, src })
      }
      target.addEventListener('click', onShow)
      return () => {
        target.removeEventListener('click', onShow)
        hideLightBox()
      }
    } else return () => hideLightBox()
  }, [className, src])

  return null
}

LightBox.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string,
  onTarget: PropTypes.func
}

export default LightBox
